import React, { PropsWithChildren } from 'react';
import { CategorySelectorDropdown as CategorySelectorDropdownNew } from './CategorySelectorDropdown';
import { convertOldCategorySelectorDropdownProps } from './converter.old';
import type { OldCategorySelectorDropdownProps } from './converter.old';

export type CategorySelectorDropdownProps<OptionValue> = OldCategorySelectorDropdownProps<OptionValue>;

export const CategorySelectorDropdown = <OptionValue extends string | number>(
  props: PropsWithChildren<CategorySelectorDropdownProps<OptionValue>>,
) => <CategorySelectorDropdownNew {...convertOldCategorySelectorDropdownProps(props)} />;
